<template>
  <div class="ExchCord">
    <div class="ExchCord-background">
      <div class="ExchCord-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        兑欧宝记录
        <p><router-link :to="{path: 'AgstOpel',query: {exsebr: this.exchbr}}">兑欧宝</router-link></p>
      </div>
      <div class="ExchCord-content">
        <div class="ExchCord-content-record" v-for="erexdrta in exdrta" :key="erexdrta.ID">
          <p><span>流水号:</span> {{erexdrta.serialnumber}}</p>
          <p><span>兑欧宝金额:</span> {{erexdrta.amount}}</p>
          <p v-if="erexdrta.state == '0'"><span>申请结果:</span> 等待确认</p>
          <p v-else-if="erexdrta.state == '1'"><span>申请结果:</span> 已确认</p>
          <p v-else-if="erexdrta.state == '2'"><span>申请结果:</span> 已到账</p>
          <p v-else-if="erexdrta.state == '3'"><span>申请结果:</span> 已撤单</p>
          <p><span>时间:</span> {{erexdrta.entertime}}</p>
        </div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + exchfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{exchtips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + exchlong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      loginID: '',
      exchbr: '',
      exchfail: 'none',
      exchtips: '',
      exdrta: '',
      exchlong: 'block'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收选择卡号传过来的卡号
    this.exchbr = this.$route.query.sechbr;
    this.$axios.post('wx/getwithdrawApply',this.$qs.stringify({
      token: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.exchlong = 'none';
      if(res.data.code == '200'){
        this.exdrta = res.data.data;
      }else{
        this.exchtips = res.data.msg;
        this.exchfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.exchfail = 'none';
        },1200)
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/ExchCord.css";
</style>